// extracted by mini-css-extract-plugin
export default {"imageWrapper":"YO-z","hovered":"ZO-z","hoverImage":"_O-z","mainImage":"aP-z","imageNoBackground":"bP-z","fullSizeImage":"cP-z"};